var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("emailCampaignModalController", [
    "$scope",
    "$rootScope",
    "mainService",
    "modalService",
    "cookiesFactory",
    "$timeout",
    "$document",
    "loaderService",
    function (
        $scope,
        $rootScope,
        mainService,
        modalService,
        cookiesFactory,
        $timeout,
        $document,
        loaderService
    ) {

        //#region Modalpoup helper
        $scope.toggleModal = function (key, state) {
            if (state) {
                modalService.open(key);
            } else {
                if (!angular.isUndefined($scope.signUpModal)) {
                    $scope.signupemail = "";
                    $scope.confirmemail = "";
                    $scope.signUpModal.form.$setPristine();
                    $scope.signUpModal.form.$setUntouched();
                    $scope.invalidEmail = false;
                }
                modalService.close(key);
            }
        };
        //#endregion

        //#region submit Email
        $scope.submitSignupEmail = function () {
            loaderService.show();
            if (
                $scope.signUpModal.form.$valid &&
                $scope.signUpModal.form.signupemail.$modelValue.toLowerCase() ==
                    $scope.signUpModal.form.confirmemail.$modelValue.toLowerCase()
            ) {
                var email = $scope.signUpModal.form.confirmemail.$modelValue;
                
                function handleResponse(response) {
                    loaderService.hide();
                    if (response.data === true) {
                        $scope.signupemail = "";
                        $scope.confirmemail = "";
                        $scope.signUpModal.form.$setPristine();
                        $scope.signUpModal.form.$setUntouched();
                        if (typeof gtag !== 'undefined' && gtag !== null) {
                            gtag('event', 'email_subscribe', {
                                'email': email.toLowerCase()
                            });
                        }
                        $scope.toggleModal("mdlSignUp", false);
                        $rootScope.$emit("ShowNotificationModal", {
                            modalKey: "SignUpEmail",
                        });
                    }
                    else if (response.data === false) {
                      $scope.invalidEmail = true;
                    }
                    else {

                        if (confirm("L'adresse e-mail saisie (" + email + ") semble incorrecte. Êtes-vous sûr de vouloir vous inscrire avec cette adresse?")) {
                            mainService.insertMailingListEmail(email.toLowerCase(), true)
                            .then(handleResponse); 
                        } 
                        else{
                            loaderService.hide();
                        } 
                    }
                }
                
                 mainService.insertMailingListEmail(email.toLowerCase(), false) 
                .then(handleResponse); 
            } else {
                $scope.signUpModal.form.confirmemail.$invalid = true;
            }
        };
        //#endregion

        //#region setting cookie value for first time user
        function initialize(){
            if (
                window.__env.firstTimeUserSignup == true &&
                window.firstTimeUserSignupmodal == "true"
            ) {
                var firstTimeUserSignup = cookiesFactory.get("FirstTimeUser");
                if (firstTimeUserSignup == null) {
                    var date = new Date();
                    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
                    var expires = "; expires=" + date.toGMTString();
                    document.cookie = "FirstTimeUser=false" + expires + "; path=/";
                    $scope.toggleModal("mdlSignUp", true);
                } else {
                    $scope.toggleModal("mdlSignUp", false);
                }
            }
        }

        $timeout(initialize,5000);
        //#endregion

        //esc click
        $document.bind('keydown', function (e) {

            if (e.keyCode==27){ //27 is ESC
               //here code for hide modal
               $scope.toggleModal("mdlSignUp", false);
            }

         });

        $scope.resetInvalidEmail = function(){
            $scope.invalidEmail = false;
        }
    },
]);
